import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'
import Register from '@/views/Register.vue'
import Admin from '@/views/Admin.vue'
import AboutView from '@/views/AboutView.vue'
import Profile from '@/views/Profile.vue'
import ResetPassword from '@/views/ResetPassword.vue'
import ForgotPassword from '@/views/ForgotPassword.vue'
import AccountVerify from '@/views/AccountVerify.vue'


import CollectionHubView from '@/views/CollectionHubView.vue'


import BooksHomeView from '@/views/books/HomeView.vue'

import BooksWishList from '@/views/books/WishList.vue'
import AddBookPost from '@/views/books/AddPost.vue'
import BookDetail from '@/views/books/BookDetail.vue'
import EditBookPost from '@/views/books/EditPost.vue'
import BookSearch from '@/views/books/Search.vue'

import AudiobooksHomeView from '@/views/audiobooks/HomeView.vue'
import AudiobooksWishList from '@/views/audiobooks/WishList.vue'
import AddAudiobookPost from '@/views/audiobooks/AddPost.vue'
import AudiobookDetail from '@/views/audiobooks/AudiobookDetail.vue'
import EditAudiobookPost from '@/views/audiobooks/EditPost.vue'
import AudiobookSearch from '@/views/audiobooks/Search.vue'

import ComicsHomeView from '@/views/comics/HomeView.vue'
import ComicsWishList from '@/views/comics/WishList.vue'
import AddComicPost from '@/views/comics/AddPost.vue'
import ComicDetail from '@/views/comics/ComicDetail.vue'
import ComicSerieDetail from '@/views/comics/SerieDetail.vue'
import EditComicPost from '@/views/comics/EditPost.vue'
import ComicSearch from '@/views/comics/Search.vue'

import MoviesHomeView from '@/views/movies/HomeView.vue'
import AddPost from '@/views/movies/AddPost.vue'
import EditPost from '@/views/movies/EditPost.vue'
import MovieDetail from '@/views/movies/MovieDetail.vue'
import MovieSearch from '@/views/movies/Search.vue'
import WishList from '@/views/movies/WishList.vue'


import store from '@/store'

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/login', name: 'Login', component: Login },
  { path: '/register', name: 'Register', component: Register },
  {
    path: '/account-verify',
    name: 'AccountVerify',
    component: AccountVerify,
    props: (route) => ({ token: route.query.token, email: route.query.email }),
  },
  { path: '/homeview', name: 'Collections', component: CollectionHubView, meta: { requiresAuth: true } },
  //{ path: '/homeview', redirect: '/collections' },
  { path: '/movies/homeview', name: 'MoviesHome', component: MoviesHomeView, meta: { requiresAuth: true } },
  { path: '/books/homeview', name: 'BooksHome', component: BooksHomeView, meta: { requiresAuth: true } },
  { path: '/audiobooks/homeview', name: 'AudiobooksHome', component: AudiobooksHomeView, meta: { requiresAuth: true } },
  { path: '/comics/homeview', name: 'ComicsHome', component: ComicsHomeView, meta: { requiresAuth: true } },

  { path: '/movies/wishlist', name: 'WishList', component: WishList, meta: { requiresAuth: true } },
  { path: '/movies/add-post', name: 'AddPost', component: AddPost, meta: { requiresAuth: true } },
  { path: '/movies/post/:id', name: 'MovieDetail', component: MovieDetail, meta: { requiresAuth: true } },
  { path: '/movies/edit-post/:id', name: 'EditPost', component: EditPost, meta: { requiresAuth: true } },
  { path: '/movies/search', name: 'MovieSearch', component: MovieSearch, meta: { requiresAuth: true } },

  { path: '/books/wishlist', name: 'BooksWishList', component: BooksWishList, meta: { requiresAuth: true } },
  { path: '/books/add-post', name: 'AddBookPost', component: AddBookPost, meta: { requiresAuth: true } },
  { path: '/books/post/:id', name: 'BookDetail', component: BookDetail, meta: { requiresAuth: true } },
  { path: '/books/edit-post/:id', name: 'EditBookPost', component: EditBookPost, meta: { requiresAuth: true } },
  { path: '/books/search', name: 'BookSearch', component: BookSearch, meta: { requiresAuth: true } },

  { path: '/audiobooks/wishlist', name: 'AudiobooksWishList', component: AudiobooksWishList, meta: { requiresAuth: true } },
  { path: '/audiobooks/add-post', name: 'AddAudiobookPost', component: AddAudiobookPost, meta: { requiresAuth: true } },
  { path: '/audiobooks/post/:id', name: 'AudiobookDetail', component: AudiobookDetail, meta: { requiresAuth: true } },
  { path: '/audiobooks/edit-post/:id', name: 'EditAudiobookPost', component: EditAudiobookPost, meta: { requiresAuth: true } },
  { path: '/audiobooks/search', name: 'AudiobookSearch', component: AudiobookSearch, meta: { requiresAuth: true } },

  { path: '/comics/wishlist', name: 'ComicsWishList', component: ComicsWishList, meta: { requiresAuth: true } },
  { path: '/comics/add-post', name: 'AddComicPost', component: AddComicPost, meta: { requiresAuth: true } },
  { path: '/comics/post/:id', name: 'ComicDetail', component: ComicDetail, meta: { requiresAuth: true } },
  { path: '/comics/serie/:serieId', name: 'ComicSerieDetail', component: ComicSerieDetail, meta: { requiresAuth: true } },
  { path: '/comics/edit-post/:id', name: 'EditComicPost', component: EditComicPost, meta: { requiresAuth: true } },
  { path: '/comics/search', name: 'ComicSearch', component: ComicSearch, meta: { requiresAuth: true } },

  { path: '/about', name: 'About', component: AboutView },
  { path: '/profile', name: 'Profile', component: Profile, meta: { requiresAuth: true } },
  { path: '/reset-password', name: 'ResetPassword', component: ResetPassword },
  { path: '/forgot-password', name: 'ForgotPassword', component: ForgotPassword },
  { path: '/admin', name: 'Admin', component: Admin, meta: { requiresAuth: true } },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) {
    next({ name: 'Home' })
    return
  }

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!store.getters['auth/isAuthenticated']) {
      next({ name: 'Login', query: { redirect: to.fullPath } })
    } else if (to.name === 'Admin' && !store.getters['auth/isAdmin']) {
      next({ name: 'Collections' })
    } else {
      next()
    }
  } else if (
    store.getters['auth/isAuthenticated'] &&
    (to.name === 'Login' || to.name === 'Register' || to.name === 'Home')
  ) {
    next({ name: 'Collections' })
  } else {
    next()
  }
})

export default router
